import * as types from './actionTypes';
import {api} from '../utility';



export function loginUserSuccess(user) {
    return { type: types.LOGIN_USER_SUCCESS, user};
}

export function logoutUserSuccess() {
  return { type: types.LOGOUT_USER_SUCCESS};
}


export function loginUser(email,password,openSnackBar,setLoginInProgress){
    return function (dispatch, getState) {
      return fetch(api.BASE_URL + api.LOGIN_ENDPOINT + `?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, {
      method: 'GET'
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      return dispatch(loginUserSuccess(data));
    })
    .catch(function(error) {
      setLoginInProgress(false);
      openSnackBar("Invalid Email/Password");
    });
    };
  }

  export function logoutUser(){
    return function (dispatch, getState) {
      dispatch(logoutUserSuccess());
    };
  }